import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';
import { COMPANY, NAV_LINKS } from '../data/site';

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-navy-deep">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
          <div>
            <img
              src="/assets/fm-wordmark-light.png"
              alt="F&M Umzüge & Entrümpelung – Wir packen das."
              data-testid="footer-logo"
              className="h-16 w-auto"
            />
            <p className="mt-5 font-display text-lg font-bold text-white">{COMPANY.slogan}</p>
            <p className="mt-1 text-sm text-slate-400">{COMPANY.tagline}</p>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-slate-500">Kontakt</p>
            <ul className="mt-5 space-y-3 text-sm text-slate-300">
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
                <span data-testid="footer-address">{COMPANY.street}, {COMPANY.city}</span>
              </li>
              <li>
                <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="flex items-center gap-3 transition-colors hover:text-white">
                  <Mail className="h-4 w-4 shrink-0 text-brand" /> {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-slate-500">Navigation</p>
            <ul className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3 text-sm">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} data-testid={`footer-${l.testid}`} className="text-slate-300 transition-colors hover:text-white">
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <Link to="/impressum" data-testid="impressum-modal-trigger" className="text-slate-300 transition-colors hover:text-white">
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/datenschutz" data-testid="datenschutz-modal-trigger" className="text-slate-300 transition-colors hover:text-white">
                  Datenschutz
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} {COMPANY.name}. Alle Rechte vorbehalten.
          </p>
          <p className="text-xs text-slate-500">{COMPANY.website}</p>
        </div>
      </div>
    </footer>
  );
}
